module.exports = __webpack_public_path__ + "small-up.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/small-up.svg?color1=%23333333&color2=
// module id = 2214
// module chunks = 67